var _ellipse, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCart = function SvgEmptyCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.2262,
    cy: 66.0551,
    rx: 58.1872,
    ry: 58.4448,
    fill: "#EFF4F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.648 58.9448C116.648 91.007 90.7718 116.996 58.8551 116.996C26.9385 116.996 1.06194 91.007 1.06194 58.9448C1.06194 26.8826 26.9385 0.893968 58.8551 0.893968C90.7718 0.893968 116.648 26.8826 116.648 58.9448Z",
    stroke: "#DCE5E1",
    strokeWidth: 0.787937
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9783 84.2686H42.3641C39.27 84.2686 36.7617 81.7492 36.7617 78.6414V50.5056C36.7617 47.3978 39.27 44.8784 42.3641 44.8784H75.9783C79.0724 44.8784 81.5806 47.3978 81.5806 50.5056V78.6414C81.5806 81.7492 79.0724 84.2686 75.9783 84.2686Z",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9755 44.8769V42.0634C68.9755 36.6247 64.586 32.2158 59.1713 32.2158V32.2158C53.7566 32.2158 49.3672 36.6247 49.3672 42.0634V42.0634V44.8769",
    stroke: "#1B382F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.7743,
    y: 55.2943,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0664,
    y: 59.6196,
    width: 9.45524,
    height: 9.45524,
    rx: 4.72762,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7402,
    y: 60.0571,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7422,
    y: 65.4868,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    fill: "#E5E5E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.60427,
    x2: 4.83416,
    y2: -0.60427,
    transform: "matrix(4.37116e-08 1 1 -4.37116e-08 58.3264 61.9282)",
    stroke: "white",
    strokeWidth: 1.20854
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.60427,
    x2: 4.83416,
    y2: -0.60427,
    transform: "matrix(-1 0 0 1 60.209 64.9751)",
    stroke: "white",
    strokeWidth: 1.20854
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 64.8833,
    y1: 68.1553,
    x2: 64.8833,
    y2: 72.5604,
    stroke: "white",
    strokeWidth: 1.09869
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 62.625,
    y1: 70.3818,
    x2: 67.0107,
    y2: 70.3818,
    stroke: "white",
    strokeWidth: 1.09869
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -2.02319,
    x2: 16.2237,
    y2: -2.02319,
    transform: "matrix(4.35189e-08 1 1 -4.39051e-08 118.373 7.61279)",
    stroke: "#FF5F5A",
    strokeWidth: 4.04637
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -2.02319,
    x2: 16.1521,
    y2: -2.02319,
    transform: "matrix(-1 0 0 1 124.668 17.8281)",
    stroke: "#FF5F5A",
    strokeWidth: 4.04637
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 8.38513,
    y2: -1.04568,
    transform: "matrix(4.35189e-08 1 1 -4.39051e-08 93.8906 33.7554)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 8.34817,
    y2: -1.04568,
    transform: "matrix(-1 0 0 1 97.1426 39.0415)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })));
};
export default SvgEmptyCart;